import { ApiHosts, handleResponseOld, makeGet } from './helpers';

type FetchCategoryCatalogIdsBySearchTermParams = {
    deployment: string;
    searchTerm: string;
    useScoutCategories?: boolean;
};

type FetchCategoryCatalogIdsBySearchTermResponse = {
    error: boolean;
    payload: [];
};

/**
 * Fetches catalog IDs from the Search API (catalogs-by-search-term) for the given search term.
 * @function fetchCatalogIdsBySearchTerm
 * @category SEARCH API
 * @param {FetchCategoryCatalogIdsBySearchTermParams}
 * @see https://search-party-DEPLOYMENT.liveauctioneers.com/search/catalogsbysearchterm?searchTerm={}
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/p8swwvetjb/resources/xi40gl/methods/GET
 */
export const fetchCatalogIdsBySearchTerm = ({
    deployment,
    searchTerm,
    useScoutCategories,
}: FetchCategoryCatalogIdsBySearchTermParams) =>
    new Promise<FetchCategoryCatalogIdsBySearchTermResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'catalogsbysearchterm',
            deployment,
            path: ApiHosts.Search,
        });

        request.query({
            searchTerm,
            ...(useScoutCategories && { useScoutCategories: true }),
        });

        request.end((err, response) => {
            handleResponseOld({ err, reject, resolve, response });
        });
    });
